<template>
  <div class="login_container">
    <div class="login_box">
      <!-- 头像区 -->
      <div class="avatar_box">
        <img src="../assets/logo.png" alt="avatar" />
      </div>
      <!-- 登录表单 -->
      <div>
        <el-form
          ref="loginFormRef"
          :model="loginForm"
          :rules="loginFormRules"
          label-width="60px"
          class="login_form"
        >
        <!--
          @keyup vue监听键盘事件
          enter 回车
          native 在自己封装的组件或者是使用一些第三方的UI库时，会发现事件并不起效果，这时就需要用到.native修饰符
                如果遇到.native修饰符也无效的情况，可能就需要用到$listeners了
          -->
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="loginForm.password"
              placeholder="请输入密码"
              type="password"
              show-password
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>
          <div class="btns">
            <el-button type="primary" @click="login">查看</el-button>
            <el-button type="info" @click="resetLoginForm">重置</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // defaultPwd:'666666',
      loginForm: {
        password: "",
      },
      // 表单验证
      loginFormRules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 18,
          //   message: "长度在 6 到 18 个字符",
          //   trigger: "blur",
          // },
        ],
      },
    };
  },
  // @keydown(){},
  methods: {
    // 表单重置按钮
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields();
    },
    login() {
      // 表单预验证
      // valid：bool类型
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return false;
        if (this.loginForm.password !== "666666")
          return this.$message.error("登录失败");
        this.$message.success("登录成功");
        window.sessionStorage.setItem("token", "test");
        this.$router.push("/home");
      });
    },
  },
};
</script>

<style scoped>
.login_container {
  height: 100%;
  /* background-image: url("../assets/backgroundvue.jpg"); */
  background-image: url("../assets/backgroundvue.jpg"); 
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /* background-size: cover; */
  /* min-height: 100vh; */
}
.login_box {
  width: 450px;
  height: 360px;
  border-radius: 10px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
}
.avatar_box {
  width: 130px;
  height: 130px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
}
img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #eee;
}
.login_form {
  position: absolute;
  bottom: 60px;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.info {
  font-size: 13px;
  margin: 10px 15px;
}

.btns{
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
